// extracted by mini-css-extract-plugin
export default {"container":"_2r7p9","imgWrapper":"_2ZQbT","bpImage":"_2GoUv","label":"_1yX03","adPageContainer":"_3wxVs","listPageContainer":"_3WGJF"};